'use client'

const GoogleTagManagerBody = () => {
  return (
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-M6VX9MZC"
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
        title="gtm"
      ></iframe>
    </noscript>
  )
}

export default GoogleTagManagerBody
